import { useState } from "react";
import Swal from "sweetalert2";
import { useFetch } from "../../../common/hooks/useFetch";
import { createRiskMatrixService } from "../services/createRiskMatrix.service";
import { deleteRiskMatrixService } from "../services/deleteRiskMatrix.service";
import { updateRiskMatrixService } from "../services/updateRiskMatrix.service";

const intitialStateRiskMatrix = {
  file: null,
  initialIdentified: "",
  finalIdentified: "",
  initialHighValuation: "",
  finalHighValuation: "",
  identifiedIssues: "",
  resolvedIssues: "",
}

export const useRiskMatrixCommond = (refresh) => {
  const fetchData = useFetch();

  const [riskMatrix, setRiskMatrix] = useState(intitialStateRiskMatrix);
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });

  const handleChangeRiskMatrix = ({ name, value }) => {
    setRiskMatrix({ ...riskMatrix, [name]: value });
  };

  const setDefaultValues = (riskMatrix) => {
    setRiskMatrix({
      file: null,
      initialIdentified: riskMatrix.initialIdentified ?? "",
      finalIdentified: riskMatrix.finalIdentified ?? "",
      initialHighValuation: riskMatrix.initialHighValuation ?? "",
      finalHighValuation: riskMatrix.finalHighValuation ?? "",
      identifiedIssues: riskMatrix.identifiedIssues ?? "",
      resolvedIssues: riskMatrix.resolvedIssues ?? "",
    });
  }

  const createRiskMatrix = async (riskMatrix) => {
    const isValid = validations(riskMatrix);
    if (!isValid) return;

    const formData = new FormData();
    formData.append("file", riskMatrix.file);
    formData.append("initialIdentified", riskMatrix.initialIdentified);
    formData.append("finalIdentified", riskMatrix.finalIdentified);
    formData.append("initialHighValuation", riskMatrix.initialHighValuation);
    formData.append("finalHighValuation", riskMatrix.finalHighValuation);
    formData.append("identifiedIssues", riskMatrix.identifiedIssues);
    formData.append("resolvedIssues", riskMatrix.resolvedIssues);

    try {
      const response = await createRiskMatrixService(fetchData)({ riskMatrix: formData });
      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Matriz de riesgos registrada",
        text: response.message,
      })
      setRiskMatrix(intitialStateRiskMatrix);
      setErrors({ hasErrors: false, errors: {} });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al registrar la matriz de riesgos",
      });
    }
  };

  const deleteRiskMatrix = async (id) => {
    try {
      const response = await deleteRiskMatrixService(fetchData)(id);
      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Matriz de riesgos eliminada",
        text: response.message,
      })
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al eliminar la matriz de riesgos",
      });
    }
  }

  const updateRiskMatrix = async (riskMatrix) => {
    const isValid = validations(riskMatrix);
    if (!isValid) return;

    const formData = new FormData();
    formData.append("file", riskMatrix.file);
    formData.append("initialIdentified", riskMatrix.initialIdentified);
    formData.append("finalIdentified", riskMatrix.finalIdentified);
    formData.append("initialHighValuation", riskMatrix.initialHighValuation);
    formData.append("finalHighValuation", riskMatrix.finalHighValuation);
    formData.append("identifiedIssues", riskMatrix.identifiedIssues);
    formData.append("resolvedIssues", riskMatrix.resolvedIssues);

    try {
      const response = await updateRiskMatrixService(fetchData)(riskMatrix.id, formData);
      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Matriz de riesgos actualizada",
        text: response.message,
      })
      setRiskMatrix(intitialStateRiskMatrix);
      setErrors({ hasErrors: false, errors: {} });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar la matriz de riesgos",
      });
    }
  }

  const validations = (riskMatrix) => {
    const newErrors = {};

    if (!riskMatrix.file) {
      newErrors.file = "El archivo es requerido";
    }

    if (!riskMatrix.initialIdentified) {
      newErrors.initialIdentified = "El valor inicial de identificado es requerido";
    }

    if (!riskMatrix.finalIdentified) {
      newErrors.finalIdentified = "El valor final de identificado es requerido";
    }

    if (!riskMatrix.initialHighValuation) {
      newErrors.initialHighValuation = "El valor inicial de alta valoración es requerido";
    }

    if (!riskMatrix.finalHighValuation) {
      newErrors.finalHighValuation = "El valor final de alta valoración es requerido";
    }

    if (!riskMatrix.identifiedIssues) {
      newErrors.identifiedIssues = "Los problemas identificados son requeridos";
    }

    if (!riskMatrix.resolvedIssues) {
      newErrors.resolvedIssues = "Los problemas resueltos son requeridos";
    }

    const hasErrors = Object.keys(newErrors).length > 0;
    setErrors({ hasErrors, errors: newErrors });

    return !hasErrors;
  }

  return { riskMatrix, handleChangeRiskMatrix, setDefaultValues, createRiskMatrix, deleteRiskMatrix, updateRiskMatrix, errors };

}
